import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drag",
  "use": "drag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"drag\"><path d=\"m8 6 4-4 4 4h-3v4h-2V6zm8 12-4 4-4-4h3v-4h2v4zm2-10 4 4-4 4v-3h-4v-2h4zM6 16l-4-4 4-4v3h4v2H6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol